import { render, staticRenderFns } from "./OrderPopUp.vue?vue&type=template&id=67046d46&"
import script from "./OrderPopUp.vue?vue&type=script&lang=js&"
export * from "./OrderPopUp.vue?vue&type=script&lang=js&"
import style0 from "./OrderPopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports